function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length,c.length);
        }
    }
    return false;
}

function createRoas(){
    /*Create a variable with the url*/
    var urlVariables = location.search.substring(1);

    /*Validate that the url contains "utm"*/
    if (urlVariables.includes('utm')) {
        setCookie('roasurl', window.location.href, 30); /*save cookie for 30 days*/
        /*If the url does not contain utm parameter, save the referrer*/
    } else if (document.referrer) {
        setCookie('roasurl', document.referrer, 30);
        /*If the url does not contain utm, or the referrer, and is false--save the first url*/
    } else {
        setCookie('roasurl', window.location.href, 30);
    }
}

$(document).ready(function(){
    
    var formWindow = $(window),
        inquireForm = $(".inquire-now"),
        inquireFormDesktop = $("#desktop-inquire-modal"),
        inquireNowDesktopCloseBtn = inquireFormDesktop.find(".close-desktop-modal"),
        collapsibleInquireBox = $(".collapsible-inquire-box"),
        collapsibleInquireBtn = $(".collapsible-inquire-title"),
        collapsibleInquireForm = $(".collapsible-inquire-form"),
        collapsibleInquireDisplayed = false,
        collapsibleInquireCounterStarted = false;

    inquireForm.submit(function(e){
        e.preventDefault();


        if($(this).find("[name='Contact']").val() == ""){
            $(this).find("[name='Contact']").addClass('invalid');
        }

        if($(this).find("[name='Email']").val() == "" || validateEmail($(this).find("[name='Email']").val()) == false ){
            $(this).find("[name='Email']").addClass('invalid');
            $(this).find(".not-valid-email-form").parent().addClass('not-email-active');
            $(this).find(".not-valid-email-form").slideDown();
        }
        
        if($(this).find(".invalid").length > 0){
            return false;
        }

        var form_data_array = $(this).serializeArray();

        var form_data = {};

        $.each(form_data_array, function(index, val){
            form_data[val.name] = val.value;
        });
        
        form_data['UsrGoogleClickId']   = getCookie('_ga');

        if(!getCookie('roasurl')){
            createRoas();
        }

        form_data['UsrSourceValue']     = getCookie('roasurl');
        
        $.ajax({
            url: "/wp-admin/admin-ajax.php",
            type: "POST",
            data: {
                action: 'submit_form',
                form_data: form_data
            },
            success: function(data) {
                window.location = "/thank-you";
            }
        });
    });

    /*email validation function*/
    function validateEmail(mail){
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)){
            return (true)
        }
        return (false)
    }

    $('.modal').modal();
    inquireNowDesktopCloseBtn.click(function(){
        inquireFormDesktop.modal('close');
    });

    collapsibleInquireBox.click(function(event){
        event.stopPropagation();
    });

    collapsibleInquireBtn.click(function(event){
        event.stopPropagation();
        if(collapsibleInquireForm.is(":visible")){
            collapsibleInquireForm.slideUp();
        }else{
            collapsibleInquireForm.slideDown();
        }
    });

    var showCollapsibleBtn = function(){
        collapsibleInquireDisplayed = true;
        collapsibleInquireBox.animate({bottom:"0px"},200);
    }

    formWindow.scroll(function(){
        var viewTop = formWindow.scrollTop();
        if(!collapsibleInquireDisplayed && viewTop > 500){
            showCollapsibleBtn();
        }
        if(!collapsibleInquireCounterStarted){
            collapsibleInquireCounterStarted = true;
            setTimeout(showCollapsibleBtn,6000);
        }
    });

    formWindow.mousemove(function(){
        if(!collapsibleInquireCounterStarted){
            collapsibleInquireCounterStarted = true;
            setTimeout(showCollapsibleBtn,6000);
        }
    });

    formWindow.click(function(){
        if(collapsibleInquireForm.is(":visible")){
            collapsibleInquireForm.slideUp();
        }
    });


    window.validate_field = function(object) {

        var hasLength = object.attr('data-length') !== undefined,
            lenAttr = parseInt(object.attr('data-length')),
            len = object.val().length;

        if (object.val().length === 0 && object[0].validity.badInput === false && !object.is(':required')) {
            if (object.hasClass('validate')) {
                object.removeClass('valid');
                object.removeClass('invalid');
            }
        } else {
            if (object.hasClass('validate')) {
                // Check for character counter attributes
                if ((object.is(':valid') && hasLength && (len <= lenAttr)) || (object.is(':valid') && !hasLength)) {
                    object.removeClass('invalid');
                    object.addClass('valid');

                } else {
                    object.removeClass('valid');
                    object.addClass('invalid');
                }
            }
        }
    }
});


// WEBPACK FOOTER //
// ./js/partials/form.js